import { DocumentType } from "../../../Types/documentsTypes";

export const quoteNotificationMessages = {
  saveSuccessMessage: "Quote saved successfully!",
  saveFailureMessage: "Failed to save quote!",
  emptyFieldMessage: "No field should be empty",
};

export const quoteDocumentFieldNames = {
  companyName: "companyName",
  companyAddress: "companyAddress",
  companyContact: "companyContact",
  quoteAddressTerms: "quoteAddressTerms",
  mainDescription: "mainDescription",
  paymentTerms: "paymentTerms",
  signatureTerms: "signatureTerms",
  quoteHeader: "quoteHeader",
};

export const buttonLabels = {
  cancel: "Cancel",
  save: "Save",
};

export const quoteHeader = {
  header: "Aggregate Supply Quote",
  paymentHeader: "Payment Terms",
  signature: "Signature",
};

export const quoteSignatureTerms = {
  leftHeader: "Signed for Twisted Nail Brokerage Services, LLC",
  rightHeader: "Signed for",
  date: "Date",
};

export const quoteSignatureTermsDetails = {
  printName: "Print Name",
  title: "Title",
  phone: "Phone",
  email: "Email",
};

export const getDefaultQuoteValues = (data?: DocumentType, id?: string) => {
  const templateQuoteValues = data?.data?.quoteContents?.find(
    (content) => content?.id === id
  );
  return {
    companyName: templateQuoteValues?.companyName,
    companyAddress: templateQuoteValues?.companyAddress,
    companyContact: templateQuoteValues?.companyContact,
    quoteAddressTerms: templateQuoteValues?.quoteAddressTerms,
    mainDescription: templateQuoteValues?.mainDescription,
    paymentTerms: templateQuoteValues?.paymentTerms,
    signatureTerms: templateQuoteValues?.signatureTerms,
    quoteHeader: templateQuoteValues?.quoteHeader,
  };
};
